import { render, staticRenderFns } from "./dialogEventInfo.vue?vue&type=template&id=b74dd52a&"
import script from "./dialogEventInfo.vue?vue&type=script&lang=js&"
export * from "./dialogEventInfo.vue?vue&type=script&lang=js&"
import style0 from "./dialogEventInfo.vue?vue&type=style&index=0&id=b74dd52a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports